//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const PermitInlineStyles: FeatureFlag = {"Id":"PermitInlineStyles","Label":"Allow html to contain inline styles","Impact":"Allow inline styles in the CSP rules.  This allows inside styles in content blocks.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
